import { render, staticRenderFns } from "./EditCustomAppointmentModal.vue?vue&type=template&id=b1a9e2b8&scoped=true"
import script from "./EditCustomAppointmentModal.vue?vue&type=script&lang=js"
export * from "./EditCustomAppointmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a9e2b8",
  null
  
)

export default component.exports